import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import * as HeroIcons from '@heroicons/react/24/outline';
import ApiEndpointCard from './ApiEndpointCard';

const ApiEndpointGroup = ({ category, initialExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);

  // Get the icon component dynamically
  const IconComponent = HeroIcons[category.icon] || HeroIcons.CubeIcon;

  return (
    <div className="api-category">
      <div
        className="api-category-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)', flex: 1 }}>
          <div style={{
            width: 40,
            height: 40,
            borderRadius: 'var(--radius-md)',
            background: 'linear-gradient(135deg, var(--color-accent-primary), var(--color-accent-secondary))',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <IconComponent style={{ width: 24, height: 24, color: 'white' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
              <h3 style={{ fontSize: '1.15rem', fontWeight: 600, color: 'var(--color-text-primary)', margin: 0 }}>
                {category.name}
              </h3>
              <span style={{
                fontSize: '0.75rem',
                color: 'var(--color-text-tertiary)',
                background: 'var(--color-bg-tertiary)',
                padding: '2px 8px',
                borderRadius: 'var(--radius-full)',
                fontWeight: 600
              }}>
                {category.endpoints.length} {category.endpoints.length === 1 ? 'endpoint' : 'endpoints'}
              </span>
            </div>
            <p style={{ fontSize: '0.9rem', color: 'var(--color-text-secondary)', margin: '4px 0 0 0' }}>
              {category.description}
            </p>
          </div>
        </div>
        <div>
          {isExpanded ? (
            <ChevronUpIcon style={{ width: 24, height: 24, color: 'var(--color-text-secondary)' }} />
          ) : (
            <ChevronDownIcon style={{ width: 24, height: 24, color: 'var(--color-text-secondary)' }} />
          )}
        </div>
      </div>

      <div className={`api-category-content ${isExpanded ? 'expanded' : ''}`}>
        <div className="api-endpoint-list">
          {category.endpoints.map((endpoint) => (
            <ApiEndpointCard key={endpoint.id} endpoint={endpoint} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApiEndpointGroup;
